import { z, ZodSchema } from "zod";
import { UseFormReturn } from "react-hook-form";
import { FieldType, Form } from "@shared/features/form/Form";

export type Props = {
  fields: FieldType[];
  form: UseFormReturn<z.infer<ZodSchema>>;
};

export function ForgotYourPasswordForm({ fields, form }: Props) {
  return (
    <>
      <Form
        fields={fields}
        form={form}
        className="w-full"
        innerClassName="justify-center"
        errorContainerClassName="p-0 mt-8"
      />
    </>
  );
}

export default ForgotYourPasswordForm;
